//#region src/extensions/text-format-extension/text-format-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Bold = "bold", e.Italic = "italic", e.Underline = "underline", e.Strike = "strike", e;
}({});
//#endregion
export { e as TextFormatEnum };
